import Lookup from './lookup.js';

export default class BodySide extends Lookup
{
    
}
